import { render, staticRenderFns } from "./ModalReturn.vue?vue&type=template&id=859c0f88&"
import script from "./ModalReturn.vue?vue&type=script&lang=js&"
export * from "./ModalReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports